import { configureStore } from "@reduxjs/toolkit";
// import reducers from "./reducers";
import rootReducer from "./reducers";

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: [],
                // Ignore these field paths in all actions
                ignoredActionPaths: ['meta.arg', 'payload.0.title'],
                // Ignore these paths in the state
                ignoredPaths: ['items.dates'],
            }
        })
})

export default store